import { screenGroupMap, GroupName } from '@config/default.config';

export interface IScreenOrderItem {
  orderNumber: number;
  pageName: GroupName;
}

// Takes the ordered screen list from BE (or default) and,
// merges only the active groups into a single flat flowTransitions object
export const buildFlowTransitions = (screenOrder: IScreenOrderItem[]) => {
  return [...screenOrder]
    .sort((a, b) => a.orderNumber - b.orderNumber)
    .reduce((acc, item) => {
      const group = screenGroupMap[item.pageName];
      if (!group) {
        console.warn(`No screen group found for pageName: "${item.pageName}"`);
        return acc;
      }
      return { ...acc, ...group };
      //  eslint-disable-next-line @typescript-eslint/no-explicit-any
    }, {} as Record<string, any>);
};